module.exports = __webpack_public_path__ + "img/back.a55ea8e8.svg";